import ApiService from './ApiService'
import { buildQs } from 'utils/queryString'

export async function apiGetCommonAddressData(data) {
    return ApiService.fetchData({
        url: '/common/address/countries',
        method: 'get',
    })
}

export async function apiGetBanksData(data) {
    const qs = buildQs(data.qs)
    return ApiService.fetchData({
        url: `/common/banks?${qs}`,
        method: 'get',
    })
}

export async function apiGetCommonBankBranchData(data) {
    return ApiService.fetchData({
        url: `/common/banks/${data.bankCode}/branchs`,
        method: 'get',
    })
}

/**

 * @param {string} owner_type nature_person | juridical_person
 */
export async function apiGetContractTemplateTypesNewstData(data) {
    return ApiService.fetchData({
        url: `/common/contract-templates/types/newst?owner_type=${data.owner_type}`,
        method: 'get',
    })
}

// /common/lessor-client-service-fee/cases 代管服務費方案說明
export async function apiGetLessorClientServiceFeeCases() {
    return ApiService.fetchData({
        url: '/common/lessor-client-service-fee/cases',
        method: 'get',
    })
}

// /lessor/v1/iot/common/providers 取得IoT供應商列表
export async function apiGetIotProvidersList() {
    return ApiService.fetchData({
        url: '/lessor/v1/iot/common/providers',
        method: 'get',
    })
}

// /lessor/v1/org-tags 組織擁有的標籤列表
export async function apiGetOrgTags(data) {
    const qs = buildQs(data)
    return ApiService.fetchData({
        url: `/lessor/v1/org-tags?${qs}`,
        method: 'get',
    })
}
